// client/src/PrivateRoute.js
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './components/Login/AuthContext';

const PrivateRoute = () => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoute;
